module.exports = __webpack_public_path__ + "img/banner_1971.ebe4a58b.png";